import { render } from "./swipes.vue?vue&type=template&id=12a2c490&scoped=true"
import script from "./swipes.vue?vue&type=script&lang=js"
export * from "./swipes.vue?vue&type=script&lang=js"

import "./swipes.vue?vue&type=style&index=0&id=12a2c490&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12a2c490"

export default script